import { Component } from '@angular/core';
import { AdminActionsDirective } from '@app/main/admin/directives/admin-actions.directive';
import { AdminService } from '../../../../admin.service';
import { IUser } from '@shared/interfaces';
import { GuardService } from '@shared/services/guard.service';
import { DialogService } from '@shared/services';
import { ModuleService } from '@shared/services/module.service';

@Component({
    selector: 'app-admin-users-info',
    templateUrl: './admin-users-info.component.html',
    styleUrls: ['./admin-users-info.component.scss'],
    standalone: false
})
export class AdminUsersInfoComponent extends AdminActionsDirective {
    constructor(
        private guardService: GuardService,
        adminService: AdminService,
        dialogService: DialogService,
        moduleService: ModuleService
    ) {
        super(adminService, dialogService, moduleService);
    }

    get isMaster(): boolean {
        return this.guardService.currentUser && this.guardService.currentUser.mainUser.id === 'Z003X1DP';
    }

    get item(): IUser {
        return this.selectedItem;
    }
}
